import React from 'react'
import logUtil from 'utils/log'
import useSelector from 'hooks/use-selector'
import useDispatch from 'hooks/use-dispatch'
import loadByHandleProductAction from 'modules/product/redux/actions/load-by-handle'
import hasSampledProductAction from 'modules/product/redux/actions/has-sampled'
import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'
// import isParentProductVariantUtil from 'modules/product-variant/utils/is-parent'

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param props.productId
 * @param props.shouldFlattenSamples
 * @param props.hasSampleVariants
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarLoad (props) {
  const {
    productVariant,
    productId,
    shouldFlattenSamples,
    hasSampleVariants
  } = props

  const loadedSampleVariant = useSelector(
    getByVariantIdDeepProductSelector(productVariant?.variant_id)
  )
  const loadedFullSizeVariant = useSelector(
    getByVariantIdDeepProductSelector(productVariant?.variant_id)
  )
  const selectedColorVariantId = useSelector(getSelectedColorVariantIdVariantSelect)
  const dispatch = useDispatch()

  const debugProps = {
    props,
    selectedColorVariantId
  }

  logUtil('QuickShopProductSidebarLoad').debug('debugProps=', debugProps)

  const loadProduct = () => {
    logUtil('QuickShopProductSidebarLoad#loadProduct').debug('debugProps=', debugProps)

    if (
      !productVariant ||
      !productId
    ) {
      logUtil('QuickShopProductSidebarLoad#loadProduct').debug('[noop] no product variant')
      return
    }

    if (productId !== productVariant?.product_id) {
      logUtil('QuickShopProductSidebarLoad#loadProduct').debug('[noop] not the same product')
      return
    }

    /**
     * Commenting this code as it was stopping gloss samples from loading if it is not the root variant
     * Reference: https://goairshop.atlassian.net/browse/AS-2092
     */

    // if (!isParentProductVariantUtil(productVariant)) {
    //   logUtil('QuickShopProductSidebarLoad#loadProduct').debug('[noop] not root variant')
    //   return
    // }

    dispatch(
      hasSampledProductAction({
        productIds: [productId]
      })
    )

    dispatch(
      loadByHandleProductAction({
        id: productId,
        handle: productVariant.handle
      })
    )

    // @see {updateSelectedVariantLoadFromUrlOnMountProductAction}
    if (selectedColorVariantId) {
      return
    }

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId: productVariant?.variant_id,
        shouldUpdateMediaGallery: (
          hasSampleVariants ||
          shouldFlattenSamples
        )
      })
    )
  }

  React.useEffect(() => {
    loadProduct()
  }, [
    productVariant,
    selectedColorVariantId,
    productId,
    loadedSampleVariant,
    loadedFullSizeVariant
  ])

  return <></>
}
